import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2, Inject, OnDestroy } from '@angular/core'; 
import { Router } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from "@angular/forms"; 
import { ViewEncapsulation } from '@angular/core'; 
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@services/security';
import { LoaderService } from '@modules/loader';
import { SendCodeModel } from '@shared/security/send-code.model';
import { VerifyCodeModel } from '@shared/security/verify-code.model';
import { AppConsts } from '@shared/app-consts';


@Component({
  selector: 'app-twofactor-verifycode',
  templateUrl: './verify-code.component.html',
  styleUrls: ['./verify-code.component.scss'] 
})
export class TwoFactorVerifyCodeComponent implements OnInit  {
    isError:boolean;
    submitted:boolean;
    IsTwoFactorRememberClient:boolean;
    receivedToken:string;
    verifyCodeForm:FormGroup;
    email:string;
    get f() { return this.verifyCodeForm.controls; }
    
    constructor(private service: AuthenticationService,
        private router: Router,
        public formBuilder: FormBuilder, 
        private loaderService: LoaderService, private renderer: Renderer2,
        @Inject(DOCUMENT) private _document) {
        }

        
  ngOnInit() {
      this.buildForm(); 
      this.email= sessionStorage.getItem(AppConsts.DecisielCurrentEmail);      
      if(!this.email || this.email == null || this.email.trim() === '')
       this.router.navigate(['login']);
  } 

 buildForm(){
     this.loaderService.hideLoader();
    this.verifyCodeForm = this.formBuilder.group({ 
        receivedToken: ["", Validators.required]
    }); 
 }

 verifyCode(){
     if(this.verifyCodeForm.invalid)
     return;
  this.submitted=true;
  let model = new VerifyCodeModel();
  model.Code = this.receivedToken;
  model.Email = this.email;
  model.Provider = sessionStorage.getItem(AppConsts.DecisielCurrentTwoFactorProvider);
  model.RememberClient = true;
  const rememberMe = sessionStorage.getItem(AppConsts.REMEMBER_ME);
  this.loaderService.showLoader();
  this.service.verifyCodeTwofactor(model).subscribe((response:any)=>{
    this.loaderService.hideLoader();
   if(response && response != null){
    this.service.signIn(response,model.Email,rememberMe);
    localStorage.setItem(AppConsts.IsTwoFactorRememberClient,"true");
    this.router.navigate(['']); 
   }
   else
   this.isError = true;
  },(error)=>{
     this.loaderService.hideLoader();     
  }); 
 }

 backToSendCode(){
    this.router.navigate(['login/send-code']); 
 }
}